import getScrollDistance from 'bundles/cds-labs/components/OverflowCarousel/getScrollDistance';

const scrollToPrevious = ({
  carouselRefCurrent,
  itemsOffset,
  isRightToLeft = false,
  offset,
}: {
  carouselRefCurrent: HTMLDivElement;
  itemsOffset: Map<string, { offsetLeft: number; offsetWidth: number }>;
  isRightToLeft?: boolean;
  offset: number;
}) => {
  const threshold = Math.abs(carouselRefCurrent.scrollLeft) - carouselRefCurrent.offsetWidth;

  // If the scroll distance to the left is less than the carousel's width, scroll back to the beginning.
  if (threshold < 0) {
    carouselRefCurrent.scrollTo({
      left: 0,
      behavior: 'smooth',
    });

    return;
  }

  const iterator = itemsOffset?.entries();
  let currentEntry = iterator?.next();

  while (!currentEntry?.done) {
    const [, value] = currentEntry?.value;
    const nextEntry = iterator?.next();

    const scrollDistance = getScrollDistance({
      value,
      isRightToLeft,
      carouselRefCurrent,
      offset,
    });

    // If there is no next item, scroll to the current item.
    if (nextEntry?.done) {
      carouselRefCurrent.scrollTo({
        left: isRightToLeft ? -scrollDistance : scrollDistance,
        behavior: 'smooth',
      });
      return;
    }

    const nextScrollDistance = getScrollDistance({
      value: nextEntry?.value?.[1],
      isRightToLeft,
      carouselRefCurrent,
      offset,
    });

    if (scrollDistance <= threshold && nextScrollDistance > threshold) {
      carouselRefCurrent.scrollTo({
        left: isRightToLeft ? -nextScrollDistance : nextScrollDistance,
        behavior: 'smooth',
      });
      return;
    }
    currentEntry = nextEntry;
  }
};

export default scrollToPrevious;
